
function alertBar() {
    const alertBar = document.querySelector('.announcementBar');
    const closeButton = document.querySelector('.announcementBar__close');

    let expiredTime = 86400; // 1 day in seconds

    if (alertBar) {
        // On close, remove alertBar from DOM and set cookie that expires in 1 day
        closeButton.addEventListener("click", function() {
            alertBar.parentNode.removeChild(alertBar);
            document.cookie = "alertBar=1; max-age=" + expiredTime + "; path=/";
        });
    }

}

function headerPin() {

    function debounce(func, wait, immediate) {
        let timeout;
        return function() {
            const context = this, args = arguments;
            const later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            const callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }

    const header = document.querySelector('.site-header');
    const stickyClass = 'is-pinned';
    const threshold = 100; // Adjust 100 to the scroll position we want
    const buffer = 10; // Adjust this buffer as needed
    let isPinned = false;

    const stickyToggle = debounce(function() {
        const scrollPosition = window.scrollY;

        if (scrollPosition > threshold + buffer) { 
            if (!isPinned) {
                header.classList.add(stickyClass);
                isPinned = true;
            }
        } else if (scrollPosition < threshold - buffer) { 
            if (isPinned) {
                header.classList.remove(stickyClass);
                isPinned = false;
            }
        }
    }, 40); // 40ms debounce period

    window.addEventListener('scroll', stickyToggle);
}

function anchorScroll() {
    document.querySelectorAll('a[href*="#"]:not([href="#"]):not([href="#0"])').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
          let target = document.querySelector(this.hash) || document.querySelector(`[name=${this.hash.slice(1)}]`);
          if (target) {
            e.preventDefault();
            window.scrollTo({ top: target.offsetTop - 76, behavior: 'smooth' });
            
            target.tabIndex = -1;
            target.focus({preventScroll: true});
          }
        }
      });
    });
  }
  

/**
 * Function to run when this module is called from site.js
 */
const init = () => {
    alertBar();
    headerPin();
    anchorScroll();
};

export default init;
